import { Box, IconButton, Stack, Typography } from '@mui/joy';
import { TrashSimple } from '@phosphor-icons/react';
import { ReactNode } from 'react';

import { Color, Direction, Level, Size, Variant } from 'theme/enums';

interface IProps {
  label: ReactNode;
  secondary?: ReactNode;
  disabled?: boolean;
  onDelete: () => void;
}

export const ChipRow = ({ label, secondary, disabled = false, onDelete }: IProps) => (
  <Stack
    direction={Direction.ROW}
    sx={{
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 1,
      padding: 1.5,
      borderRadius: 'sm',
      backgroundColor: 'neutral.100',
    }}
  >
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography level={Level.TITLE_SM}>{label}</Typography>
      {secondary}
    </Box>

    <IconButton
      size={Size.SM}
      color={Color.DANGER}
      variant={Variant.PLAIN}
      disabled={disabled}
      onClick={onDelete}
    >
      <TrashSimple />
    </IconButton>
  </Stack>
);
